
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 20.6"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M13.7 6.1V1.5A1.5 1.5 0 0011.3.3l-7 5.8H1.9A2 2 0 000 8v4.6a2 2 0 002 1.9h2.3l7 5.8a1.5 1.5 0 001 .3 1.5 1.5 0 001.4-1.5v-4.6a5 5 0 000-8.4zm.8 4.2a3.4 3.4 0 01-.8 2.1V8.2a3.4 3.4 0 01.8 2.2zM1.5 8a.4.4 0 01.4-.4h2.7a.8.8 0 00.5-.2l7.1-5.9v17.6l-7.1-6a.8.8 0 00-.5-.1H1.9a.4.4 0 01-.4-.4z","data-name":"Layer 1"}})])])
          )
        }
      }
    